import AuthService from '@apiService/AuthService';
import Spinner from '@components/partials/Spinner';
import { currencyFormatter } from '@helper/currencyFormatter';
import { useEffect, useState } from 'react';
import { withNamespaces } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

const Transactions = () => {
  const history = useHistory();
  const loginDetails = useSelector((state) => state.auth);
  // console.log({ loginDetails });
  const { loggedInUser, userHistory, guestUser } = loginDetails;
  const [userBookings, setUserBookings] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [bookingFilters, setBookingFilters] = useState([
    { type: 1, name: 'Upcoming', isSelected: true },
    { type: 2, name: 'Past', isSelected: false },
    { type: 3, name: 'Refunded', isSelected: false },
  ]);
  const [selectedBookingFilter, setSelectedBookingFilter] = useState(1);

  const handleFilterClick = async (type, index) => {
    setSelectedBookingFilter(type);

    await getCustomerBookingData(type);
  };

  const getCustomerBookingData = async (type = 1) => {
    try {
      setIsLoading(true);
      const response = await AuthService.GetCustomerHistoryV2({
        isCustomer: loggedInUser && loggedInUser.hasOwnProperty('cust_id'),
        customer_id: loggedInUser?.cust_id || guestUser?.guest_id,
        type,
      });
      setIsLoading((prevState) => !prevState);
      if (response.data.status && response.data.Records.length) {
        setUserBookings([...response.data.Records]);
      } else {
        setUserBookings([]);
      }
    } catch (error) {
      console.log({ error }, 'from get user history of customers');
    }
  };

  const handleShareClick = (bookingObj) => {
    if (!bookingObj.t_sb_booking_code) return;
    history.push(
      `/final-ticket/${bookingObj.t_sb_booking_code}/${bookingObj.cinema_id}`,
    );
  };

  useEffect(() => {
    getCustomerBookingData();
  }, []);
  return (
    <>
      <div className="d-flex">
        {bookingFilters.map((bookingFilterObj, bookingFilterIndex) => {
          return (
            <div
              className={`user-history-filters ${
                selectedBookingFilter == bookingFilterObj.type
                  ? 'user-history-filters-selected'
                  : ''
              }`}
              onClick={() => {
                handleFilterClick(bookingFilterObj.type, bookingFilterIndex);
              }}
            >
              {bookingFilterObj.name}
            </div>
          );
        })}
      </div>
      <div className="user-history-table-container">
        <table className="user-history-table">
          <thead class="user-history-table-heading">
            <th className="text-left">Location</th>
            <th className="text-left">Movies</th>
            <th className="text-left">Time</th>
            <th className="text-left">Date</th>
            <th className="text-left">Booking ID</th>
            <th className="text-left">F&B</th>
            <th className="text-right">Paid</th>
            <th className="text-right"></th>
          </thead>
          <tbody>
            {!userBookings.length ? (
              <tr>
                <td colSpan={8} className="text-center">
                  No Records
                </td>
              </tr>
            ) : isLoading ? (
              <tr>
                <td colSpan={8} className="text-center">
                  <Spinner />
                </td>
              </tr>
            ) : (
              userBookings.map((userBookingObj) => {
                return (
                  <tr class="user-history-table-row">
                    <td class="text-left text-truncate">
                      {userBookingObj.cinema_name}
                    </td>
                    <td class="text-left">{userBookingObj.movie_name}</td>
                    <td class="text-left">{userBookingObj.t_show_time}</td>
                    <td class="text-left">{userBookingObj.t_show_date}</td>
                    <td class="text-left">{userBookingObj.t_sb_booking_code}</td>
                    <td class="text-left text-wrap">
                      {userBookingObj.fnb_items
                        ? userBookingObj.fnb_items.split(',').join(', ')
                        : '-'}
                    </td>
                    <td class="text-right">
                      {currencyFormatter(userBookingObj.amount_paid)}
                    </td>
                    {selectedBookingFilter != 3 && (
                      <td>
                        <div onClick={() => handleShareClick(userBookingObj)}>
                          <button class="user-history-ticket-btn">
                            <svg
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.50938 13.0094C4.38447 13.0044 5.22615 12.6727 5.86938 12.0794L12.1294 15.6594C12.0496 15.9356 12.0092 16.2218 12.0094 16.5094C12.003 17.3209 12.2764 18.1099 12.7836 18.7434C13.2908 19.377 14.0008 19.8164 14.7941 19.9877C15.5873 20.1591 16.4154 20.0518 17.1389 19.6841C17.8623 19.3163 18.437 18.7105 18.7661 17.9686C19.0951 17.2268 19.1585 16.3942 18.9456 15.6111C18.7326 14.8279 18.2563 14.1421 17.5969 13.669C16.9375 13.196 16.1352 12.9646 15.3251 13.0138C14.515 13.063 13.7467 13.3899 13.1494 13.9394L6.88938 10.3594C6.96493 10.1129 7.00533 9.85707 7.00938 9.59936L13.1594 6.07936C13.7534 6.6162 14.514 6.93244 15.3136 6.97506C16.1131 7.01767 16.903 6.78406 17.5508 6.31341C18.1985 5.84275 18.6648 5.16368 18.8713 4.39008C19.0778 3.61647 19.012 2.79539 18.6849 2.06454C18.3579 1.33368 17.7895 0.7375 17.0751 0.375986C16.3606 0.0144709 15.5436 -0.0903923 14.7611 0.078983C13.9785 0.248358 13.278 0.681671 12.777 1.30625C12.2759 1.93082 12.0049 2.70868 12.0094 3.50936C12.0128 3.79666 12.0531 4.08234 12.1294 4.35936L6.43938 7.60936C6.10969 7.09931 5.65295 6.68384 5.11406 6.40376C4.57518 6.12369 3.97268 5.98866 3.36581 6.01194C2.75893 6.03523 2.16855 6.21603 1.65271 6.53657C1.13687 6.85712 0.713312 7.30637 0.423672 7.84018C0.134032 8.37399 -0.0117219 8.97397 0.000736668 9.58117C0.0131952 10.1884 0.183437 10.7819 0.49473 11.3033C0.806022 11.8248 1.24765 12.2563 1.77621 12.5554C2.30477 12.8546 2.90206 13.011 3.50938 13.0094ZM15.5094 15.0094C15.8061 15.0094 16.0961 15.0973 16.3427 15.2622C16.5894 15.427 16.7817 15.6612 16.8952 15.9353C17.0087 16.2094 17.0384 16.511 16.9806 16.802C16.9227 17.093 16.7798 17.3602 16.57 17.57C16.3603 17.7798 16.093 17.9227 15.802 17.9805C15.511 18.0384 15.2094 18.0087 14.9354 17.8952C14.6613 17.7816 14.427 17.5894 14.2622 17.3427C14.0974 17.096 14.0094 16.806 14.0094 16.5094C14.0094 16.1115 14.1674 15.73 14.4487 15.4487C14.73 15.1674 15.1116 15.0094 15.5094 15.0094ZM15.5094 2.00936C15.8061 2.00936 16.0961 2.09733 16.3427 2.26215C16.5894 2.42698 16.7817 2.66124 16.8952 2.93533C17.0087 3.20942 17.0384 3.51102 16.9806 3.80199C16.9227 4.09297 16.7798 4.36024 16.57 4.57002C16.3603 4.7798 16.093 4.92266 15.802 4.98054C15.511 5.03841 15.2094 5.00871 14.9354 4.89518C14.6613 4.78165 14.427 4.58939 14.2622 4.34271C14.0974 4.09604 14.0094 3.80603 14.0094 3.50936C14.0094 3.11153 14.1674 2.73 14.4487 2.4487C14.73 2.16739 15.1116 2.00936 15.5094 2.00936ZM3.50938 8.00936C3.80605 8.00936 4.09606 8.09733 4.34274 8.26215C4.58941 8.42698 4.78167 8.66124 4.8952 8.93533C5.00873 9.20942 5.03844 9.51102 4.98056 9.80199C4.92268 10.093 4.77982 10.3602 4.57004 10.57C4.36026 10.7798 4.09299 10.9227 3.80202 10.9805C3.51104 11.0384 3.20944 11.0087 2.93535 10.8952C2.66127 10.7816 2.427 10.5894 2.26218 10.3427C2.09735 10.096 2.00938 9.80603 2.00938 9.50936C2.00938 9.11153 2.16741 8.73 2.44872 8.4487C2.73002 8.16739 3.11155 8.00936 3.50938 8.00936Z"
                                fill="#00aad3"
                              />
                            </svg>
                          </button>
                        </div>
                      </td>
                    )}
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default withNamespaces()(Transactions);
